import { get } from 'lodash';
import queryString from 'query-string';
import { call, put, select } from 'redux-saga/effects';
import { API } from '../../api';
import { getTimelineQuery } from './get-timeline-query';

export const getServerConfig = ({ serverConfig }) => serverConfig;

export function* downloadCSV(action) {
  yield put({ type: 'START_REPORT_LOADING' });
  yield put({
    type: 'OPEN_SNACKBAR',
    payload: {
      message: 'Your file will download shortly.',
    },
  });

  const payload = get(action, 'payload', {});
  const {
    filterString, props, source, timeline, parcel_ids
  } = payload;

  const serverConfig = yield select(getServerConfig);
  const timelineQuery = yield call(getTimelineQuery, { timeline });

  const query = {
    props: (
      props || [
        'parcel_id',
        'add_combo',
        'esttcv',
        'lst_sle_dt',
        'occStatus',
        'owner_name',
        'own_prop_ct',
        'rb_flr_ar_num',
        'rb_nbed',
        'bath_num',
        'rb_yr_blt',
        'cib_flr_ar_num',
        'structure',
        'general_zoning',
        'zoning',
        'taxStatus',
        'mortgageForeclosure',
        'taxForeclosure',
      ]
    ).join(','),
    ...timelineQuery,
  };

  if (parcel_ids && parcel_ids.length) query.parcel_id = parcel_ids[0];
  if (source) query.source = source;

  const downloadQueryString = queryString.stringify(query);

  const queries = [
    filterString,
    downloadQueryString,
  ]
    .filter(Boolean)
    .join('&');


  try {
    const path = `/csv/${serverConfig.namespace}${queries ? `?${queries}` : ''
      }`;

    yield call(API, 'get', 'api', path);
  } catch (e) {
    console.error(e);
  }
  yield put({ type: 'STOP_REPORT_LOADING' });
}
